import React from "react";
import styled from "styled-components";
import MarkersMap from "../Elements/MarkersMap";

export default function Pricing() {
  return (
    <Wrapper id="location">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Our Warehouses</h1>
            <p className="font13">
              We deliver your cargo by land, water or air anywhere in the world!
              <br />
              Qua Logistics is located on different region where its easy to
              access from anywhere.
            </p>
          </HeaderInfo>
          <MarkersMap />
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 50px 0;
`;
const HeaderInfo = styled.div`
  margin-bottom: 50px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const TablesWrapper = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const TableBox = styled.div`
  width: 31%;
  @media (max-width: 860px) {
    width: 100%;
    max-width: 370px;
    margin: 0 auto;
  }
`;
